import { DataSource, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutOrderHandlingRequirementsSlideout extends Layout {
    panelHandReq: Panel;
    panelHandReqCol1: Panel;
    panelMain: Panel;
    sourceBrltlOrderHdrXFgp: DataSource;
    sourceHandlingRequirements: DataSource;
}
